import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';

function Appearance() {

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub | Admin / Appearance";
  }, []);

  return (
    <SidebarPageLayout>
      <div className="content p-5">
        <h1 className="mb-0">Appearance</h1>
      </div>
    </SidebarPageLayout>
  );
}

export default Appearance;
